import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./lib/authContext";
import Layout from "./components/Layout";
import HomeOrDashboard from "./pages/HomeOrDashboard";
import DevocionalDia from "./pages/DevocionalDia";
import Sermoes from "./pages/Sermoes";
import SermaoDetalhe from "./pages/SermaoDetalhe";
import Videos from "./pages/Videos";
import Livros from "./pages/Livros";
import Oracao from "./pages/Oracao";
import Planos from "./pages/Planos";
import PlanoDetalhe from "./pages/PlanoDetalhe";
import PlanoDia from "./pages/PlanoDia";
import Semana from "./pages/Semana";
import Admin from "./pages/Admin";
import AdminTestWebhook from "./pages/AdminTestWebhook";
import AdminInboxDetail from "./pages/AdminInboxDetail";
import Landing from "./pages/Landing";
import Historico from "./pages/Historico";
import Biblia from "./pages/Biblia";
import BibliaLivro from "./pages/BibliaLivro";
import BibliaCapitulo from "./pages/BibliaCapitulo";
import Comunidade from "./pages/Comunidade";
import Favoritos from "./pages/Favoritos";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import EsqueciSenha from "./pages/EsqueciSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import Diario from "./pages/Diario";
import AuthCallback from "./pages/AuthCallback";
import Assistente from "./pages/Assistente";
import Jornada from "./pages/Jornada";
import Onboarding from "./pages/Onboarding";
import SharePage from "./features/share/SharePage";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="landing" element={<Landing />} />
            {/* Compartilhamento público, modo imersivo sem Layout/nav. */}
            <Route path="share/:id" element={<SharePage />} />
            <Route element={<Layout />}>
              <Route index element={<HomeOrDashboard />} />
              <Route path="devocional" element={<DevocionalDia />} />
              <Route path="devocional/:id" element={<DevocionalDia />} />
              <Route path="sermoes" element={<Sermoes />} />
              <Route path="sermoes/:id" element={<SermaoDetalhe />} />
              <Route path="estudos-breves" element={<Sermoes kind="brief_study" />} />
              <Route path="estudos-breves/:id" element={<SermaoDetalhe />} />
              <Route path="videos" element={<Videos />} />
              <Route path="livros" element={<Livros />} />
              <Route path="oracao" element={<Oracao />} />
              <Route path="planos" element={<Planos />} />
              <Route path="planos/:slug" element={<PlanoDetalhe />} />
              <Route path="planos/:slug/dia/:n" element={<PlanoDia />} />
              <Route path="semana" element={<Semana />} />
              <Route path="historico" element={<Historico />} />
              <Route path="biblia" element={<Biblia />} />
              <Route path="biblia/:book" element={<BibliaLivro />} />
              <Route path="biblia/:book/:chapter" element={<BibliaCapitulo />} />
              <Route path="comunidade" element={<Comunidade />} />
              <Route path="favoritos" element={<Favoritos />} />
              <Route path="entrar" element={<Login />} />
              <Route path="cadastro" element={<Cadastro />} />
              <Route path="bem-vindo" element={<Onboarding />} />
              <Route path="esqueci-senha" element={<EsqueciSenha />} />
              <Route path="redefinir-senha" element={<RedefinirSenha />} />
              <Route path="diario" element={<Diario />} />
              <Route path="jornada" element={<Jornada />} />
              <Route path="assistente" element={<Assistente />} />
              <Route path="auth/google/callback" element={<AuthCallback />} />
              <Route path="admin" element={<Admin />} />
              <Route path="admin/test-webhook" element={<AdminTestWebhook />} />
              <Route path="admin/inbox/:id" element={<AdminInboxDetail />} />
              {/* Aliases comuns para evitar 404 silencioso (tela em branco) */}
              <Route path="admin/login" element={<Navigate to="/entrar" replace />} />
              <Route path="login" element={<Navigate to="/entrar" replace />} />
              <Route path="signup" element={<Navigate to="/cadastro" replace />} />
              <Route path="register" element={<Navigate to="/cadastro" replace />} />
              <Route path="forgot-password" element={<Navigate to="/esqueci-senha" replace />} />
              {/* Catch-all: qualquer rota desconhecida → home (evita tela em branco) */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "hsl(var(--navy))",
            color: "white",
            border: "1px solid hsl(var(--gold) / 0.3)",
          },
        }}
      />
    </div>
  );
}
